export class ChatMessage {
  message: string;
  fromUsername: string;
  fromId: string;
  groupId: string;
  date: Date;
  isRead: boolean;
}

export class MessageGroup {
  groupName: string;
  groupId: string;
  lastMessage: Date;
  messages: ChatMessage[];
} 
